import React from 'react'
import Pager from '../../components/models/Pager/Pager.js'
import Placeholder from '../../components/models/Placeholder/Placeholder.js';
import VideoPager from '../../components/models/VideoPager/VideoPager.js';
import InterrogateSources from '../../components/models/InterrogateSources/InterrogateSources.js'
import BinaryTally from '../../components/models/BinaryTally/BinaryTally.js';
import Reflection from '../../components/models/Reflection/Reflection.js';
import WiderLook from '../../components/models/WiderLook/WiderLook.js';
import Sliders from '../../components/models/Sliders/Sliders.js';
import TaskModel from '../../components/models/TaskModel/TaskModel.js';
import FindTheError from '../../components/models/FindTheError/FindTheError.js';
import Accordion from "../../components/models/Accordion/Accordion";
import Orbits from '../../components/models/Orbits/Orbits.js';
import ModesOfOperation from '../../components/models/ModesOfOperation/ModesOfOperation.js';
import TabActivities from '../../components/models/TabActivities/TabActivities.js';
import MissionElements from "../../components/models/MissionElements";
import Interaction8 from '../../components/models/Interaction8/Interaction8.js';
import Interaction5 from "../../components/models/Interaction5/Interaction5.js";
import Benchmarking from '../../components/models/Benchmarking/Benchmarking.js';
import ConflictResolution from '../../components/models/ConflictResolution/ConflictResolution.js';
import Launch from '../../components/models/Launch';
import OrbitAndReview from '../../components/models/OrbitAndReview';
import SensorSelect from "../../components/models/SensorSelect/SensorSelect";
// import CoinDrill from '../../components/models/CoinDrill/CoinDrill.js'
import KickingOffTheConversation from '../../components/models/KickingOffTheConversation/KickingOffTheConversation.js';
import ErrorDisplay from '../../components/models/ErrorDisplay/ErrorDisplay.js';
import MultiTabs from '../../components/models/MultiTabs/MultiTabs.js';
import ExploreTheConcepts from '../../components/models/ExploreTheConcepts/ExploreTheConcepts.js';
import HotspotWithQuestions from '../../components/models/HotspotWithQuestions/HotspotWithQuestions.js';
import SubTeamMeeting from "../../components/models/SubTeamMeeting/SubTeamMeeting.js";
import TeamMeeting from '../../components/models/TeamMeeting/TeamMeeting.js';
import ChapterOpener from "../../components/models/ChapterOpener/ChapterOpener";
import Payload from '../../components/models/Payload/Payload.js';
import CommsPayload from '../../components/models/Comms/Payload';
import CommsLink from '../../components/models/Comms/Link';
import CollapsibleMenu from '../../components/models/CollapsibleMenu/CollapsibleMenu.js'
import VerticalTabs from '../../components/models/VerticalTabs/VerticalTabs.js';
import HorizontalTabs from '../../components/models/HorizontalTabs/HorizontalTabs.js';
import BusSat from '../../components/models/BusSat/BusSat.js';
import QualityStartsWithYou from "../../components/models/QualityStartsWithYou/QualityStartsWithYou";
import VideoPager2 from '../../components/models/VideoPager2/VideoPager2'
import LaunchLocation from '../../components/models/LaunchLocation'
import ClickGraphicsActivities from '../../components/models/ClickGraphicsActivities/ClickGraphicsActivities'
import FullteamMeeting from '../../components/models/FullteamMeeting'

//remove for push
import VerticalAccordionContainer from '../../components/partials/VerticalAccordionContainer/VerticalAccordionContainer'
import SplashPage from '../../components/partials/SplashPage/SplashPage.jsx';
import CommsSimulator from "../../components/models/CommsSimulator/CommsSimulator";

const InteractionRegistry = (interactionType = 'placeholder', props) => {
    const lowerCase = interactionType.toLowerCase();

    if(lowerCase === 'pager') {
        return (<Pager {...props}/>)
    }
    if(lowerCase === 'binary-tally') {
        return (<BinaryTally {...props}/>)
    }
    if(lowerCase === 'interrogate-sources') {
        return (<InterrogateSources {...props}/>)
    }
    if(lowerCase === 'reflection') {
        return (<Reflection {...props}/>)
    }
    if(lowerCase === 'wider-look') {
        return (<WiderLook {...props}/>)
    }
    if(lowerCase === 'video-pager') {
        return (<VideoPager {...props}/>)
    }
    if(lowerCase === 'sliders') {
        return (<Sliders {...props}/>)
    }
    if(lowerCase === 'taskmodel') {
        return (<TaskModel {...props}/>)
    }
    if(lowerCase === 'findtheerror') {
        return (<FindTheError {...props} />)
    }
    if(lowerCase === 'teammeeting') {
        return (<TeamMeeting {...props}/>)
    }
    if(lowerCase === 'orbits'){
        return(<Orbits {...props} />)
    }
    if(lowerCase === 'modesofoperation'){
        return(<ModesOfOperation {...props} />)
    }
    if(lowerCase === 'interaction8') {
        return (<Interaction8 {...props}/>)
    }
    if(lowerCase === 'benchmarking') {
        return (<Benchmarking {...props} />)
    }
    if(lowerCase === 'conflict-resolution') {
        return (<ConflictResolution {...props}/>)
    }
    if (lowerCase === "interaction5") {
        return <Interaction5 {...props} />;
    }
    // if(lowerCase === 'coindrill') {
    //     return (<CoinDrill {...props}/>)
    // }
    if(lowerCase === 'verticalaccordion') {
        return (<KickingOffTheConversation {...props}/>)
    }
    if(lowerCase === 'quality-starts-with-you') {
        return (<QualityStartsWithYou {...props}/>)
    }
    if(lowerCase === 'error-display') {
        return (<ErrorDisplay {...props}/>)
    }
    if(lowerCase === 'missionelements') {
        return (<MissionElements {...props}/>)
    }
    if(lowerCase === 'accordion') {
        return (<Accordion {...props}/>)
    }
    if(lowerCase === 'multitabs') {
        return (<MultiTabs {...props}/>)
    }
    if(lowerCase === 'launch') {
        return (<Launch {...props}/>)
    }
    if(lowerCase === 'exploretheconcepts') {
        return (<ExploreTheConcepts {...props}/>)
    }
    if(lowerCase === 'orbit-and-review') {
        return (<OrbitAndReview {...props}/>)
    }
    if(lowerCase === 'sensorselect') {
        return (<SensorSelect {...props}/>)
    }
    if(lowerCase === 'hotspot-with-questions') {
        return (<HotspotWithQuestions {...props}/>);
    }
    if(lowerCase === 'subteammeeting') {
        return (<SubTeamMeeting {...props}/>)
    }
    if(lowerCase === 'bussat') {
        return (<BusSat {...props}/>)
    }
    if(lowerCase === 'payload') {
        return (<Payload {...props}/>)
    }
    if(lowerCase === 'chapteropener') {
        return (<ChapterOpener {...props}/>)
    }
    if(lowerCase === 'commspayload') {
        return (<CommsPayload {...props}/>)
    }
    if(lowerCase === 'commslink') {
        return (<CommsLink {...props}/>)
    }
    if (lowerCase === 'commssimulator') {
        return (<CommsSimulator {...props} />)
    }
    if(lowerCase === 'verticaltabs') {
        return (<VerticalTabs {...props} />)
    }
    if(lowerCase === 'collapsiblemenu') {
        return (<CollapsibleMenu {...props}/>)
    }
    if(lowerCase === 'horizontaltabs') {
        return (<HorizontalTabs {...props}/>)
    }
    if(lowerCase === "component_test"){
        return (<VerticalAccordionContainer {...props}/>)
    }
    if(lowerCase === "video-pager2"){
        return (<VideoPager2 {...props}/>)
    }
    if(lowerCase === "tabactivities"){
        return (<TabActivities {...props}/>)
    }
    if(lowerCase === "splashscreen"){
        return (<SplashPage {...props}/>)
    }
    if(lowerCase === "launch-location"){
        return (<LaunchLocation {...props}/>)
    }
    if(lowerCase === "clickgraphicsactivities"){
        return (<ClickGraphicsActivities {...props}/>)
    }
    if(lowerCase === "fullteam-meeting"){
        return (<FullteamMeeting {...props}/>)
    }


  return <Placeholder {...props} />;
};

export default InteractionRegistry
